var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgStackoverflowinline = function SvgStackoverflowinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 40 40"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 19.375,
    stroke: "#fff",
    strokeOpacity: 0.15,
    strokeWidth: 1.25
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "m25.868 19.917-.533 1.893-10.667-1.893.466-2.082zm.267-.505-10-4.416.933-1.892 10 4.415zm1.2-2.397-8.4-6.688h-.067l1.4-1.577 8.467 6.688zm-2 7.318H14.668v-1.892h10.667zm1.998-3.786v5.678H12.667v-5.678H10v8.202h20v-8.202z",
    clipRule: "evenodd"
  })));
};
export default SvgStackoverflowinline;